import { useEffect, useMemo, useState } from 'react';
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
import editIcon from "../../../assets/icon/pencil-fill.svg"
import editIconWhite from "../../../assets/icon/pencil-fill-white.svg";
import deletIcon from "../../../assets/icon/trash-solid.svg";
import deletIconWhite from "../../../assets/icon/trash-solid-white.svg";


const CustomReactMaterialTable = ({
    data,
    columns,
    page,
    isEdit,
    isDelete,
    location,
    setSelectedRowData,
    setShowModal,
    setWitchAction,
    selectedRow,
    isLoading,
    isActionColumn,
    isPagination,
    
  }) => {
      const [resetKey, setResetKey] = useState(0);

      useEffect(() => {
        setResetKey((prevKey) => prevKey + 1);
      }, [data, isLoading]);

    const overrideColumn = {
        id: 'actions',
        accessorKey: 'actions',
        header: 'Actions',
        enableColumnFilter:false,
        size: 100,
        accessorFn: (rowData) => (
          <div> 
            <div style={{ textAlign: 'center' }}> 
              {(isEdit !== false || (location?.pathname === '/Admin/clinicalintakerequest' && rowData.ApprovedSatus === 0)) ? (
                <img
                  src={selectedRow === rowData?.tableData?.id ? editIconWhite : editIcon}
                  width="11"
                  className="m-2 cursor-pointer"
                  alt="edit icon"
                  onClick={() => {
                    setWitchAction('update');
                    setSelectedRowData(rowData);
                    setShowModal(true);
                  }}
                />
              ) : (
                <div className="m-2" style={{ height: '11px', width: '11px' }}></div>
              )}
              {isDelete !== false && (
                <img
                  src={selectedRow === rowData?.tableData?.id ? deletIconWhite : deletIcon}
                  width="11"
                  className="m-2 cursor-pointer"
                  alt="delete icon"
                  onClick={() => {
                    setWitchAction('delete');
                    setSelectedRowData(rowData);
                    setShowModal(true);
                  }}
                />
              )}
            </div>
          </div>
        ),
      };
      
  
    const updatedColumns = useMemo(() => {
      const existingColumns = columns || []; 
      return [...existingColumns, overrideColumn];
    }, [columns, overrideColumn]);
    
    const table = useMaterialReactTable({
      columns: isActionColumn === false ? columns : updatedColumns,
        data,
        enableRowPinning:false,
        enableColumnActions: false,
        enableSorting:false,
        enableColumnFilters:false,
        enableFullScreenToggle:false,
        enableDensityToggle:false,
        enableHiding:false,
        enableStickyHeader:true,
        enableGlobalFilterModes:true,
        enablePagination:isPagination === false ? false : true,
        muiPaginationProps: {
            showRowsPerPage: false,
        },
        enableFacetedValues: true,
        // paginationDisplayMode: 'pages',
        // columnFilterDisplayMode: hasFilterableColumns === true ? 'popover' : "",
        state: { isLoading: isLoading },
        initialState: { showGlobalFilter: true , showColumnFilters : true},
        muiRowProps: rowData => ({
          sx: {
            padding: '0px',
            fontSize: '11px',
            fontFamily: 'Arial',
            border: '1px solid #dee2e6',
            textAlign: 'start',
            ...(rowData.tableData.id === table.state.selectedRow
              ? {
                  color: 'white',
                  backgroundColor: '#999999',
                }
              : {}),
          },
        }),
        muiCellProps: {
          sx: {
            textAlign: 'left',
          },
        },
        muiTableHeadCellProps: {
          sx: {
              padding: '0px',
              zIndex: 0,
              backgroundColor: '#18252D',
              color: '#EEF0E2',
              textTransform: 'capitalize',
              fontSize: '11px',
              fontFamily: 'Arial',
              fontWeight: '700',
              verticalAlign: "top",
              border: '1px solid #dee2e6',
              borderRight: page === 'Ranked' || page === 'grouplist' ? '2px solid #dee2e6' : '1px solid #dee2e6',
              borderLeft: page === 'Ranked' || page === 'grouplist' ? '2px solid #dee2e6' : '1px solid #dee2e6',
              '& .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root': {
                  backgroundColor: "#FFFFFF", 
                  borderRadius: 0,
                  fontSize: "11px !important",
                  width:'max-content !important',
              },
              '& .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root div': {
                padding: "5px !important" , 
                fontSize: "11px !important"
              },
              
          },
      },
        muiTableBodyCellProps: {
            sx: {
                fontSize: '11px',
                fontFamily: 'Arial',
            },
        },
        muiTableContainerProps: {
          sx: { maxHeight: '600px' }, 
        },
        muiSearchTextFieldProps: {
            placeholder: `Search`,
            sx: {
                width: '210px',
                fontSize:"11px",
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        border: 'none',
                        display: 'block !important',
                        borderBottom: '1px solid #ced4da',
                    },
                    '& input': {
                        fontSize: '17px', 
                        paddingLeft: '0', 
                    },
                    '& .MuiSvgIcon-root': {
                        width: '18px', 
                        height: '18px', 
                    },
                },
            },
            variant: 'outlined',
        },
        muiFilterTextFieldProps: {
            sx: { m: '0.5rem 0', width: '100%' },
            variant: 'outlined',
          },
          
      }); 
    return <MaterialReactTable table={table} key={resetKey}/>
  };
  
  export default CustomReactMaterialTable;
  


